const transformToAssocArray = (prmstr: any) => {
    const params = {};
    const prmarr = prmstr.split("&");
    for (let i = 0; i < prmarr.length; i++) {
        let tmparr = prmarr[i].split("=") // @ts-ignore
        params[tmparr[0]] = tmparr[1];
    }
    return params
}

export const getSearchParameters = () => {
    const params = window.location.search.substr(1);
    return params != null && params != "" ? transformToAssocArray(params) : {};
}

export const isObject = (val: any): boolean => typeof val === 'object';

export const blockedClientErrorCode = (err:string):boolean => {
    const blockedErrorCode = ['400', '401', '429', 'Request aborted', 'Network']
    let blockSend: boolean = false

    blockedErrorCode.map(code => {
        const regexp = new RegExp(code)
        if (regexp.test(err)) blockSend = true
    })

    return blockSend
}
